import React, {useEffect, useState} from 'react'
import {useAuth} from '../../modules/auth'
import axios from 'axios'

function Activo() {
  return <span className="badge badge-light-success">Activo</span>
}

function Prueba() {
  return <span className="badge badge-light-success bg-prueba">Prueba</span>
}

function Promocion() {
  return <span className="badge badge-light-success bg-prueba">Promoción</span>
}

function PagoFallido() {
  return <span className="badge badge-light-danger">Pago Fallido</span>
}
function Cancelado() {
  return <span className="badge badge-light-danger">Cancelado</span>
}

function NoPagado() {
  return <span className="badge badge-light-danger bg-no-pagado">No Pagado</span>
}

function Sistema() {
  return <span className='badge badge-light bg-sistema'>Sistema</span>
}

function Demo() {
  return <span className='badge badge-light bg-sistema'>Demo</span>
}

function Plan(props) {
  const plan = props.plan;

  switch (plan) {
    case 'Adinte Anual':
      return "Adinte Anual";

    case 'Adinte Mensual':
      return "Adinte Mensual";

    case 'Admin':
      return "Admin";

    default:
      return "N/A";
  }
}

function Status(props) {
  const statusPago = props.statusPago;
  if (statusPago=='Prueba') {
    return <Prueba />;
  }else if(statusPago=='Promocion') {
    return <Promocion />;
  }else if(statusPago=='Activo') {
    return <Activo />;
  }
  else if(statusPago=='Pago fallido') {
    return <PagoFallido />;
  }
  else if(statusPago=='Cancelado') {
    return <Cancelado />;
  }
  else if(statusPago=='No Pagado') {
    return <NoPagado />;
  }
  else if (statusPago=='Sistema') {
    return <Sistema />
  }
  else if(statusPago=='Demo') {
    return <Demo />
  }
  return <NoPagado />;
}



function TablaUsuarios(props) {
  const usuarios = props.usuarios
  const API_URL = process.env.REACT_APP_API_URL

  

  const displayItems = () => {
    if (usuarios) {
      if (usuarios.length > 0) {
        return usuarios.map((usuario, index) => {
          return (
            <tr key={index}>
              <td>{usuario.first_name} {usuario.last_name}</td>
              <td>{usuario.phone}</td>
              <td>{usuario.email}</td>
              <td>{usuario.company}</td>
              <td>{usuario.employees}</td>
              <td>{usuario.state}</td>
              <td>{usuario.city}</td>
              <td>{usuario.total_exp}</td>
              <td>{usuario.expiration_time}</td>
              <td><Plan plan={usuario.plan} /></td>
              <td><Status statusPago={usuario.subscription} /></td>
              <td>
                <button  onClick={() => props.showUser(usuario.id)}  className='btn btn-secondary'><i className="fas fa-eye"></i></button>
                <button  onClick={() => props.deleteUser(usuario.id)} className='btn btn-secondary'><i className="fas fa-trash"></i></button>
              </td>
            </tr>
          )
        })
      }
    }
  }

  return <>{displayItems()}</>
}

export {TablaUsuarios}



